'use client'

import { useEffect } from 'react'
import { getWakeWordDetectionService, WakeWordDetectionService } from '@/lib/voice/wake-word-detection-service'
import { getLinkLiveSession } from '@/lib/voice/link-live-session'

export function VoiceManager() {
  useEffect(() => {
    const initVoice = async () => {
        // Initialize singleton
        getLinkLiveSession() 
        
        // Check if Hey Link is enabled in settings (mocked from localStorage)
        const settings = localStorage.getItem('linkbox_voice_settings')
        if (settings) {
            const parsed = JSON.parse(settings)
            if (parsed.heyLinkEnabled) {
                // We need user interaction to start audio context usually.
                // This might fail on page load, but will work if user navigated here.
                try {
                    await getWakeWordDetectionService().startListening()
                } catch (e) {
                    console.log('Waiting for user interaction to start voice...')
                    const startHandler = async () => {
                        await getWakeWordDetectionService().startListening()
                        document.removeEventListener('click', startHandler)
                        document.removeEventListener('keydown', startHandler)
                    }
                    document.addEventListener('click', startHandler)
                    document.addEventListener('keydown', startHandler)
                }
            }
        }
    }
    
    initVoice()
  }, [])

  return null
}
